import { IRequest } from 'common/schema/request/Request';
import { MetadataConditional } from './MetadataConditional';

export class MetadataConditionalLogic {
  /**
   * Verifica se una condizione è applicabile.
   */
  static isVerified(condition: MetadataConditional, value: string) {
    // Non possiamo verificare una condizione parziale, in quel caso
    // assumiamo sempre sia valida.
    if (!condition.metadataId || !condition.value) return true;

    const targetValues = Array.isArray(condition.value)
      ? condition.value
      : [condition.value];

    return targetValues.includes(value);
  }

  /**
   * Utility per estrarre direttamente il value dalla request.
   */
  static isVerifiedInRequest(
    condition: MetadataConditional,
    request: IRequest
  ) {
    // Non possiamo verificare una condizione parziale, in quel caso
    // assumiamo sempre sia valida.
    if (!condition.metadataId || !condition.value) return true;

    const value = request.values[condition.metadataId] as any;
    return MetadataConditionalLogic.isVerified(condition, value);
  }
}
